import {
    Button,
    Col,

    Row,

} from "react-bootstrap";
import { Controller } from "react-hook-form";
import { TextInput } from "../../components/inputs/Inputs";

export const ContratoSearchSection = ({ control, errors, onSearchContrato }) => (
    <div className="bg-light p-4 rounded-4 border border-light mb-4">
        <h5 className="fw-bold text-secondary mb-3">Buscar Contrato</h5>
        <Row className="g-3 align-items-end">
            <Col md={8}>
                <Controller
                    control={control}
                    name="numero_ctto"
                    render={({ field }) => (
                        <div>
                            <label className="text-muted small fw-bold text-uppercase mb-2">Nº Contrato</label>
                            <TextInput
                                {...field}
                                noFloating={true}
                                error={errors.numero_ctto?.message}
                                placeholder="Ingrese el número de contrato"
                                className="bg-white shadow-sm"
                            />
                        </div>
                    )}
                />
            </Col>
            <Col md={4}>
                <Button
                    variant="primary"
                    className="rounded-pill w-100 fw-bold shadow-sm"
                    onClick={onSearchContrato}
                >
                    Buscar Contrato
                </Button>
            </Col>
        </Row>
    </div>
);